exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resort-item .price-cta[data-v-50c89d33]{position:absolute;top:0;right:0;text-align:right}.discount-tag[data-v-50c89d33]{font-size:12px;padding:3px 6px;border-radius:4px}", ""]);

// exports
